import Axios from "axios";
import Authorization from './auth';
import { executeCall } from "./utils";

const crudder = (domain) => (resource, withAuth = true) => {
    const url = `${domain}/${resource}`;

    const getHeaders = () => withAuth ? Authorization() : {};

    return {
        get options() {
            return { headers: getHeaders(), url };
        },
        getAll: () => executeCall(() => Axios.get(url, { headers: getHeaders() })),
        getOne: (id) => executeCall(() => Axios.get(url + '/' + id, { headers: getHeaders() })),
        create: (data) => executeCall(() => Axios.post(url, data, { headers: getHeaders() })),
        update: (data) => executeCall(() => Axios.patch(url, data, { headers: getHeaders() })),
        delete: (options) => executeCall(() => Axios.delete(url, { data: options, headers: getHeaders() })),
    };
};


export default crudder;